// Plan Distribuidor: no tiene app de conductor, asi que los pedidos cambian de estado y los
// viajes se cierran a mano desde la web. El backend es quien manda (403 a cualquier otro plan
// o perfil); esto solo evita mostrar controles que no van a funcionar.
const MANUAL_STATE_PROFILE_NAMES = ['planner', 'supervisor', 'customer_admin', 'superadmin'];

export const isDistributorPlan = (company) => company?.subscription_plan_slug === 'distribuidor';

export const canCloseManually = (authUser) => {
    const company = authUser?.current_company;
    if (!isDistributorPlan(company)) return false;

    const profiles = Array.isArray(authUser?.profiles) ? authUser.profiles : [];
    return profiles.some((profile) => (
        profile?.name === 'superadmin' ||
        (profile?.company_id === company?.id && MANUAL_STATE_PROFILE_NAMES.includes(profile?.name))
    ));
};
